const collection = {
  slug: "yohji-yamamoto-brother-yakuza-suit-guide",
  metaTitle:
    "Yohji Yamamotoのヤクザスーツとは｜北野武『BROTHER』と黒いセットアップ完全ガイド",
  metaDescription:
    "Yohji Yamamotoのスーツがなぜ特別なのか。北野武監督『BROTHER』の衣装、黒いヤクザスーツ、布の余白、落ち感、身体の輪郭を消す強さ、Yohji Yamamoto POUR HOMMEやY’sの魅力まで解説。ヨウジヤマモトを初めて知る人にも分かるEnclopediaのアーカイブガイドです。",
  metaKeywords:
    "Yohji Yamamoto スーツ,ヨウジヤマモト スーツ,ヨウジヤマモト ヤクザスーツ,Yohji Yamamoto ヤクザスーツ,ヨウジヤマモト 北野武,Yohji Yamamoto BROTHER,北野武 BROTHER 衣装,ヨウジヤマモト BROTHER,Yohji Yamamoto POUR HOMME,ヨウジヤマモトプールオム,Y's ワイズ,Yohji Yamamoto 黒,ヨウジヤマモト 黒,ヨウジヤマモト セットアップ,ヨウジヤマモト アーカイブ,Yohji Yamamoto アーカイブ,ヨウジヤマモト レンタル,Yohji Yamamoto レンタル,enclopedia,アンクロペディア",
  canonicalPath: "/archive_collection/yohji-yamamoto-brother-yakuza-suit-guide",
  heroImage: "media/archive_fashion/archive7.png",
  heroImageAlt:
    "Yohji Yamamotoの黒いスーツと北野武『BROTHER』の衣装を解説するEnclopediaアーカイブガイド画像",
  heroNumber: "07 / YOHJI SUIT",
  label: "ARCHIVE DESIGNER STUDY",
  title: "Yohji Yamamotoのヤクザスーツとは。黒と余白で作る別の強さ",
  lead: "Yohji Yamamotoのスーツは、身体の輪郭を消すことで別の強さを作った服です。\n\nいわゆるヤクザスーツと呼ばれるような、黒く、ゆるく、重く、少し怖いセットアップ。\nそれは身体を誇示するスーツではなく、身体の気配を隠しながら、着る人の存在感だけを残す服です。\n\n西洋のスーツが、肩幅や胸板で男性性を作ってきたとするなら、Yohjiのスーツは、布の余白、落ち感、黒の沈黙で男性の強さを作り直しました。",
  keywordLine: ["yohji yamamoto", "brother", "black suit", "yakuza suit"],
  thesis:
    "Yohji Yamamotoのスーツの強さは、身体を大きく見せることではなく、身体の輪郭を消し、黒と余白によって存在感だけを残す点にあります。",
  whyTitle: "なぜYohji Yamamotoの黒いスーツは、怖くて、色気があるのか。",
  whyBody:
    "一般的なスーツは、身体を整えるための服です。\n肩を作り、胸を張らせ、ウエストを絞り、着る人を社会的に正しく見せる。\nしかしYohji Yamamotoのスーツは、その方向とは違います。\n\n身体を強調するのではなく、布の中に沈める。\n輪郭をはっきり見せるのではなく、黒い余白の中に気配だけを残す。\nその結果、着る人の身体そのものよりも、存在感、沈黙、危うさが前に出てきます。\n\n北野武監督『BROTHER』のスーツが今も強く記憶されるのは、単にヤクザ映画の衣装だからではありません。\nYohji Yamamotoの黒いセットアップが、暴力を派手に見せるのではなく、静けさと重さとして表現していたからです。",
  pillars: [
    {
      number: "01",
      title: "BLACK AS SILENCE",
      text: "Yohji Yamamotoの黒は、ただ暗い色ではありません。光を吸い込み、身体の輪郭を曖昧にし、言葉よりも沈黙で存在感を作る色です。",
    },
    {
      number: "02",
      title: "SPACE AROUND BODY",
      text: "身体にぴったり沿うスーツではなく、身体と布の間に余白を作る。そこに、怖さ、余裕、色気が生まれます。",
    },
    {
      number: "03",
      title: "CINEMA INTO CLOTHES",
      text: "北野武『BROTHER』の衣装は、映画の中の記号でありながら、Yohji Yamamotoのスーツ観を理解する入口でもあります。",
    },
  ],
  readingTitle: "黒、余白、北野武映画から読むYohji Yamamotoのスーツ。",
  readingIntro:
    "Yohji Yamamotoのスーツは、単に黒くて大きい服ではありません。身体の見せ方、男性性の作り方、映画の中での沈黙、シルバーアクセサリーとの相性まで見ることで、なぜあのスーツが忘れられないのかが見えてきます。",
  observations: [
    {
      index: "01",
      title: "身体の輪郭を消すことで、存在感だけを残す",
      text: "Yohji Yamamotoのスーツは、肩幅や胸板で男性性を誇示する服ではありません。\nむしろ、布の分量によって身体の輪郭を曖昧にします。\nジャケットは少し大きく、パンツはゆるく落ち、黒い布が身体の線を飲み込む。\n\nそれなのに、着る人の存在感は消えません。\n身体そのものは見えにくくなるのに、気配だけが強く残る。\nここに、Yohjiのスーツの怖さと色気があります。",
    },
    {
      index: "02",
      title: "西洋のスーツが作った男性性を、黒い余白で作り直す",
      text: "西洋のクラシックなスーツは、身体を理想化する服です。\n肩を構築し、胸を立体的に見せ、ウエストを絞ることで、強い男性像を作ってきました。\n\n一方でYohji Yamamotoのスーツは、身体を理想化しません。\n布が余り、落ち、揺れることで、身体を固定された男性像から解放します。\n強さは筋肉やシェイプではなく、黒、沈黙、余白、落ち感から生まれる。\nそれは、男性服の強さを別の方向へ開いたデザインです。",
    },
    {
      index: "03",
      title: "『BROTHER』のスーツは、暴力よりも沈黙を着ている",
      text: "北野武監督『BROTHER』で印象的なのは、激しい暴力そのものよりも、登場人物の静けさです。\nYohji Yamamotoが手がけた衣装は、その沈黙とよく合います。\n\n黒いスーツ、ゆるいジャケット、広がるパンツ、硬すぎないシャツ。\nそれは“強そうに見せる衣装”ではなく、何を考えているか分からない身体を作るための服です。\n感情を隠し、輪郭を隠し、しかし存在感だけは強く残す。\nそれが、映画の中のYohjiのスーツが持つ独特の迫力です。",
    },
    {
      index: "04",
      title: "なぜシルバーアクセサリーがあんなに似合うのか",
      text: "Yohji Yamamotoの黒いスーツに、シルバーアクセサリーが似合う理由は明確です。\n黒い布が身体の輪郭を消す一方で、シルバーは光を一点に集めます。\nつまり、黒が沈黙を作り、シルバーが視線の焦点を作る。\n\n『BROTHER』の衣装制作をきっかけに生まれたシルバーアクセサリーは、現在のGOTHIC YOHJI YAMAMOTOにつながる象徴的なクリエーションの起源の一つとしても語られています。\n服が余白を作り、アクセサリーがその余白に緊張感を与える。\nだからYohjiのスーツとシルバーは、ただの装飾以上に相性が良いのです。",
    },
    {
      index: "05",
      title: "Yohji Yamamoto POUR HOMMEは、男性服の型を崩す中心線",
      text: "Yohji Yamamoto POUR HOMMEは、Yohjiのメンズ表現を考えるうえで重要なラインです。\n黒いテーラリング、ワイドパンツ、長いシャツ、ドレープ、非対称、未完成に見えるディテール。\nそれらは、男性服をだらしなくするためではなく、既存のスーツやジャケットが持つ男性性を別の形へ変えるために使われています。\n\nYohjiのスーツを理解するなら、POUR HOMMEの黒いセットアップやワイドパンツは最も分かりやすい入口です。",
    },
    {
      index: "06",
      title: "Y’sは、Yohjiの思想を日常に近い距離で着る入口",
      text: "Yohji Yamamotoの世界観は、POUR HOMMEだけで完結しません。\nY’sは、より日常に近い距離でYohjiの思想に触れられるラインです。\n黒、余白、ドレープ、実用性、身体を締めつけない設計。\n\nPOUR HOMMEが映画的で強い存在感を持つなら、Y’sは日常の中でその思想を静かに着る入口です。",
    },
    {
      index: "07",
      title: "ヤクザスーツという呼び方の奥にあるもの",
      text: "“ヤクザスーツ”という言葉は分かりやすい一方で、Yohji Yamamotoのスーツをそれだけで説明すると浅くなります。\n重要なのは、怖さの演出ではありません。\n黒い布が身体を隠し、余白が距離を作り、落ち感が力の抜けた緊張感を生むこと。\n\nYohjiのスーツは、威圧するための服ではなく、近づきにくい沈黙を作る服です。\nだからこそ、ヤクザ映画の中でも、ただの衣装ではなく、人物の気配そのものとして残ります。",
    },
  ],
  quote:
    "Yohji Yamamotoのスーツは、身体を大きく見せるのではなく、身体を消すことで存在感を強くする。",
  perspectiveTitle:
    "Enclopediaは、Yohji Yamamotoのスーツを“黒い服”ではなく“身体の見え方を変えたアーカイブ”として読む。",
  perspectiveCards: [
    {
      number: "01",
      title: "KNOWLEDGE",
      text: "北野武『BROTHER』、Yohji Yamamoto POUR HOMME、Y’s、黒いテーラリングの文脈をつなぎ、なぜYohjiのスーツが特別なのかを可視化します。",
    },
    {
      number: "02",
      title: "EXPERIENCE",
      text: "Yohjiのスーツは写真だけでは伝わりにくい服です。布の重さ、落ち感、余白、歩いたときの揺れは、実際に着ることで理解が深まります。",
    },
    {
      number: "03",
      title: "COMMUNITY",
      text: "Yohji Yamamoto、Y’s、北野武映画、シルバーアクセサリー、黒いセットアップに惹かれる人が集まる文脈を作り、アーカイブへの入口を広げます。",
    },
  ],
  experienceTitle:
    "Yohjiのスーツは、読むだけではなく、着ることで沈黙の強さが分かる。",
  experienceBody:
    "画面上では黒いセットアップとして見える服も、実際に身体へ乗ると、布の重さ、落ち感、余白の量、歩いたときの揺れ方として理解できます。\nEnclopediaでは、アーカイブを所有物ではなく、考え方を身体で辿るメディアとして扱います。\nYohji Yamamotoのスーツは、その体験と非常に相性の良い服です。",
  experienceItems: [
    "黒い布の重さと落ち感を身体で知る",
    "オーバーサイズと余白が作る存在感を体感する",
    "背景を読んだ後にレンタルで確かめる",
  ],
  archiveItemsTitle: "この黒の強さを、実物で確かめる。",
  archiveItemsBody:
    "在庫導線には、Yohji Yamamotoのスーツや黒いセットアップの文脈と接続できる視点を添えます。単なる一覧ではなく、ブランド理解の続きを設計します。",
  archiveItems: [
    {
      label: "ARCHIVE FOCUS 03",
      title: "Everyday Yohji Yamamoto Archive",
      productPath: "/brand/YOHJI%20YAMAMOTO（ヨウジヤマモト）/?number=71",
      productImage: "",
      text: "Yohjiの思想を近い距離で体験する入口。黒、余白、実用性、身体を締めつけない設計を確かめる導線。",
    },
  ],
};

export default collection;
